import type { SVGProps } from "react";

const INK_LIGHT = "hsl(222,47%,11%)";
const CREAM = "#f2ede3";
const DARK_FILL = "hsl(222,20%,18%)";

type IllustrationProps = SVGProps<SVGSVGElement> & { isDark?: boolean };

function illustrationColors(isDark?: boolean) {
  return {
    paper: isDark ? DARK_FILL : CREAM,
    ink: isDark ? CREAM : INK_LIGHT,
  };
}

export function OfertyIllustration({ isDark, ...props }: IllustrationProps) {
  const { paper, ink } = illustrationColors(isDark);
  return (
    <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="12" y="8" width="32" height="40" rx="2" fill={paper} stroke={ink} strokeWidth="1.5" />
      <line
        x1="18"
        y1="16"
        x2="34"
        y2="16"
        stroke={ink}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeOpacity="0.3"
      />
      <line
        x1="18"
        y1="22"
        x2="38"
        y2="22"
        stroke={ink}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeOpacity="0.3"
      />
      <line
        x1="18"
        y1="28"
        x2="30"
        y2="28"
        stroke={ink}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeOpacity="0.3"
      />
      <circle cx="40" cy="40" r="9" fill="#c7541f" />
      <path
        d="M36 40L38.5 42.5L44 37"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UmowyIllustration({ isDark, ...props }: IllustrationProps) {
  const { paper, ink } = illustrationColors(isDark);
  return (
    <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        x="14"
        y="12"
        width="28"
        height="32"
        rx="2"
        fill={paper}
        stroke={ink}
        strokeWidth="1.5"
        strokeOpacity="0.4"
      />
      <rect x="22" y="12" width="12" height="4" rx="1" fill={ink} fillOpacity="0.4" />
      <circle cx="28" cy="28" r="6" stroke={ink} strokeWidth="1.5" strokeOpacity="0.4" />
      <path
        d="M28 25V28L30 30"
        stroke={ink}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeOpacity="0.4"
      />
    </svg>
  );
}

export function HarmonogramyIllustration({ isDark, ...props }: IllustrationProps) {
  const { ink } = illustrationColors(isDark);
  return (
    <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        x="16"
        y="16"
        width="6"
        height="6"
        rx="1"
        fill={ink}
        fillOpacity="0.15"
        stroke={ink}
        strokeWidth="1.5"
        strokeOpacity="0.4"
      />
      <rect
        x="16"
        y="30"
        width="6"
        height="6"
        rx="1"
        fill={ink}
        fillOpacity="0.15"
        stroke={ink}
        strokeWidth="1.5"
        strokeOpacity="0.4"
      />
      <rect
        x="16"
        y="44"
        width="6"
        height="6"
        rx="1"
        fill={ink}
        fillOpacity="0.4"
        stroke={ink}
        strokeWidth="1.5"
        strokeOpacity="0.4"
      />
      <line
        x1="19"
        y1="22"
        x2="19"
        y2="30"
        stroke={ink}
        strokeWidth="1.5"
        strokeDasharray="2 2"
        strokeOpacity="0.3"
      />
      <line
        x1="19"
        y1="36"
        x2="19"
        y2="44"
        stroke={ink}
        strokeWidth="1.5"
        strokeDasharray="2 2"
        strokeOpacity="0.3"
      />
      <line
        x1="22"
        y1="19"
        x2="38"
        y2="19"
        stroke={ink}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeOpacity="0.3"
      />
      <line
        x1="22"
        y1="33"
        x2="34"
        y2="33"
        stroke={ink}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeOpacity="0.3"
      />
      <line
        x1="22"
        y1="47"
        x2="30"
        y2="47"
        stroke={ink}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeOpacity="0.3"
      />
    </svg>
  );
}

export function KosztyIllustration({ isDark, ...props }: IllustrationProps) {
  const { paper, ink } = illustrationColors(isDark);
  return (
    <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14 20C14 18.3431 15.3431 17 17 17H39C40.6569 17 42 18.3431 42 20V42C42 43.6569 40.6569 45 39 45H17C15.3431 45 14 43.6569 14 42V20Z"
        fill={paper}
        stroke={ink}
        strokeWidth="1.5"
        strokeOpacity="0.4"
      />
      <path
        d="M20 17V14C20 12.8954 20.8954 12 22 12H34C35.1046 12 36 12.8954 36 14V17"
        stroke={ink}
        strokeWidth="1.5"
        strokeOpacity="0.4"
      />
      <rect
        x="20"
        y="25"
        width="12"
        height="8"
        rx="1"
        fill={ink}
        fillOpacity="0.15"
        stroke={ink}
        strokeWidth="1.5"
        strokeOpacity="0.4"
      />
      <circle cx="34" cy="36" r="3" fill={ink} fillOpacity="0.4" />
      <line x1="20" y1="29" x2="32" y2="29" stroke={ink} strokeWidth="1.5" strokeOpacity="0.3" />
    </svg>
  );
}
